import { useState } from "react";
import { TreeSelect, Flex } from "antd";

import ChevronDownIcon from "@/icons/ChevronDownIcon";
import CloseCircleIcon from "@/icons/CloseCircleIcon";
import LockCloseIcon from "@/icons/LockClosedIcon";
const CustomTreeSelect = ({
  data,
  value,
  onChange,
  placeholder = "Начните вводить",
  style,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen((prev) => !prev);
  };

  // Тут зашиты все настройки для TreeSelect, если нужно что-то поменять, то лучше переписать компонент как CustomSelect
  return (
    <TreeSelect
      treeData={data}
      value={value}
      onChange={onChange}
      multiple
      placeholder={placeholder}
      style={style}
      treeCheckable
      treeCheckStrictly
      treeDefaultExpandAll
      showCheckedStrategy={TreeSelect.SHOW_ALL}
      maxTagCount="responsive"
      popupMatchSelectWidth={false}
      onOpenChange={toggleOpen}
      treeNodeFilterProp="title"
      fieldNames={{
        label: "title",
      }}
      allowClear={{ clearIcon: <CloseCircleIcon /> }}
      suffixIcon={
        <ChevronDownIcon
          style={{
            fontSize: 14,
            transform: `rotate(${isOpen ? "-180deg" : "0"})`,
          }}
        />
      }
      treeTitleRender={(item) => {
        return (
          <Flex align="center" gap={8}>
            {item.readOnly && <LockCloseIcon style={{ color: "#bbb" }} />}

            {item.title}
          </Flex>
        );
      }}
    />
  );
};

export default CustomTreeSelect;
